const extended = () => {
  const showProperties = (callBack = () => {}) => {
    if (callBack) callBack()
  }
  return {
    showProperties,
  }
}

export default extended
